module.exports = "/contribution/resources/stochastic_template_params.csv";